<template>
  <div>
    <Baseloader v-if="loading" />
    <div
      v-if="grainesAsItems && grainesAsItems.length > 0 && !loading"
    >
      <div
        class="d-flex overflow-x"
      >
        <v-card
          v-if="hasChoixToutesCultures"
          class="ma-1 cursor"
          color="#DBBD00"
        >
          <v-btn
            v-if="'Tous' === codeGraineSelected"
            class="position-check white size-btn"
            icon
          >
            <v-icon
              size="32"
              color="#7a8001"
            >
              mdi-check-circle-outline
            </v-icon>
          </v-btn>
          <v-hover v-slot="{ hover }">
            <v-img
              :height="$vuetify.breakpoint.mobile ? '96px' : '98px'"
              :width="$vuetify.breakpoint.mobile ? '128px' : '144px'"
              gradient="0deg,  black -30%, transparent 50%"
              :class="'Tous' === codeGraineSelected || hover ? 'border' : ''"
              @click="change('Tous')"
            >
              <div class="titre-h4-medium ml-3 mr-2 white--text position-detail">
                Toutes mes cultures de vente
              </div>
            </v-img>
          </v-hover>
        </v-card>
        <v-slide-group
          v-model="model"
          center-active
          class="max-width-870"
        >
          <template v-slot:next>
            <v-btn
              fab
              small
              class="position-btn-nav-right"
            >
              <v-icon
                color="#7a8001"
              >
                mdi-chevron-right
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:prev>
            <v-btn
              fab
              small
              class="position-btn-nav-left"
            >
              <v-icon
                color="#7a8001"
              >
                mdi-chevron-left
              </v-icon>
            </v-btn>
          </template>
          <v-slide-item
            v-for="(item, i) in grainesAsItems"
            :key="i"
            v-slot="{ active, toggle }"
          >
            <v-card
              :color="item.color"
              class="ma-1 cursor"
              @click="toggle"
            >
              <v-btn
                v-if="item.codeGraine === codeGraineSelected"
                class="position-check white size-btn"
                icon
              >
                <v-icon
                  size="32"
                  color="#7a8001"
                >
                  mdi-check-circle-outline
                </v-icon>
              </v-btn>
              <v-hover v-slot="{ hover }">
                <v-img
                  :height="$vuetify.breakpoint.mobile ? '96px' : '98px'"
                  :width="$vuetify.breakpoint.mobile ? '128px' : '144px'"
                  gradient="0deg,  black -30%, transparent 50%"
                  :class="item.codeGraine === codeGraineSelected || hover ? 'border' : ''"
                  @click="change(item.codeGraine)"
                >
                  <div class="texte ml-3 mr-2 white--text position-sub-detail">
                    <v-icon
                      color="white"
                      size="20"
                      class="mr-2"
                    >
                      mdi-sprout
                    </v-icon>{{ item.surface }} ha
                  </div>
                  <div class="titre-h4-medium ml-3 mr-2 white--text position-detail">
                    {{ item.text }}
                  </div>
                </v-img>
              </v-hover>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </div>
    </div>
    <div
      v-if="grainesAsItems && grainesAsItems.length=== 0 && !loading"
      class="d-flex pt-3"
    >
      <BaseMessage
        type="info"
        text
        color="secondary"
        message="Aucune graine pour cette récolte"
      />
    </div>
  </div>
</template>

<script>
import { findIndex, round } from 'lodash'
import capitalize from '@/filters/string.filter'
import BaseMessage from '@/components/common/base-message.vue'
import Baseloader from '@/components/common/base-loader.vue'

export default {
  name: 'NavMenuGraineCulturial',
  components: {BaseMessage, Baseloader},
  props: {
    /**
     * Code graine de l'onglet sélectionné.
     */
    value: {
      type: String,
      default: null
    },
    /**
     * graines des différents onglets.
     */
    graines: {
      type: Array[Object],
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    anneeRecolteSelected: {
      type: String,
      default: null
    },
    hasChoixToutesCultures: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      model: null,
      codeGraineSelected: null
    }
  },

  computed: {
    getColors () {
      const palette = [
        '#027F5F', '#138659', '#238E53', '#33954D', '#449D47', '#54A441',
        '#64AB3B', '#74B335', '#84BA2F', '#94C229', '#A5C923', '#B5D11D',
        '#C5D817', '#D5DF11', '#E6E70A'
      ]
      const n = palette.length
      if (this.graines.length >= n || this.graines.length === 1 ) return palette
      const result = []
      for (let j = 0; j < this.graines.length; j++) {
        const index = Math.round((j * (n - 1)) / (this.graines.length - 1))
        result.push(palette[index]) 
      }
      return result
    },
    grainesAsItems () {
      return this.graines.map((graine, i) => {
        return {
          codeGraine: graine.code,
          text: capitalize.capitalize(graine.libelle),
          surface: round(graine.surface, 0),
          color: this.getColors[i]
        }
      })
    },
  },
  watch: {
    value () {
      if (this.value != null) {
        this.codeGraineSelected = this.value
      }
      else {
        this.codeGraineSelected = 'Tous'
      }
      this.model = findIndex(this.graines, ((g) => g.code === this.codeGraineSelected))
    },
    graines () {
      this.model = findIndex(this.graines, ((g) => g.code === this.codeGraineSelected))
    }
  },
  created () {
    this.codeGraineSelected = this.value ? this.value : 'Tous'
    this.model = findIndex(this.graines, ((g) => g.code === this.codeGraineSelected))
  },
  methods: {
    change (codeGraine) {
      if (codeGraine === 'Tous') {
        this.codeGraineSelected = 'Tous'
      } else if (codeGraine != null && this.graines.findIndex(g => g.code === codeGraine) > -1) {
        this.codeGraineSelected = codeGraine
      } else if (this.grainesAsItems.length) {
        this.codeGraineSelected = this.grainesAsItems[0].codeGraine
      } else {
        this.codeGraineSelected = null
      }
      this.$emit('change', this.codeGraineSelected)
    }
  }
}
</script>

<style lang="scss" scoped>
.position-detail {
  position: absolute;
  bottom: 8px;
}
.position-sub-detail {
  position: absolute;
  top: 10px;
}
.position-check {
  position: absolute;
  top: -2px;
  right: -2px;
  z-index: 1;
}
.position-btn-nav-right {
  position: absolute;
  top: 35px;
  right: 0;
  z-index: 1;
}
.position-btn-nav-left {
  position: absolute;
  top: 35px;
  left: 0;
  z-index: 1;
}
.v-btn--icon.v-size--small {
    height: 19px;
    width: 19px;
}
.border {
  border: 3px solid rgba(150, 154, 39);
  border-radius: 15px;
}
.size-btn {
  width: 21px;
  height: 21px;
}
.cursor {
  cursor: pointer;
}
.overflow-x {
  overflow-x: auto;
}
.max-width-870 {
  max-width: 870px;
}

</style>
